/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Group_AccountInputs */

const en_settings_v2_group_account = /** @type {(inputs: Settings_V2_Group_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const es_settings_v2_group_account = /** @type {(inputs: Settings_V2_Group_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Settings_V2_Group_AccountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_group_account = /** @type {((inputs?: Settings_V2_Group_AccountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Group_AccountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_group_account(inputs)
	return en_settings_v2_group_account(inputs)
});